<template>
  <v-form ref="loyaltyTierForm" v-model="valid">
    <v-row style="width: 100%" wrap>
      <v-flex shrink px-2 xs12>
        <v-text-field
              v-model="driverGroup.name"
              style="font-size: 11px !important;"
              hide-details
              label="Name"
            />
      </v-flex>
      <v-flex shrink px-2 xs12>
        <v-text-field
              v-model="driverGroup.callsignPrefix"
              style="font-size: 11px !important;"
              hide-details
              label="Callsign Prefix"
            />
      </v-flex>
      <v-flex pt-2 shrink px-2 xs12>
        <v-checkbox
              v-model="driverGroup.enabled"
              style="font-size: 11px !important;"
              hide-details
              label="Enabled"
            />
      </v-flex>
      <v-flex pt-2 shrink px-2 xs12>
        <v-checkbox
              v-model="driverGroup.vipEligible"
              style="font-size: 11px !important;"
              hide-details
              label="VIP Eligible"
            />
      </v-flex>
      <v-flex pt-2 shrink px-2 xs12>
        <v-checkbox
              v-model="driverGroup.limitToDriverIndicatedBoundary"
              style="font-size: 11px !important;"
              hide-details
              label="Limit to Driver Indicated Boundary"
            />
      </v-flex>
      <v-flex pt-2 shrink px-2 xs12>
        <v-select
              v-model="driverGroup.includeInEtaPolicy"
              :items="etaPolicies"
              style="font-size: 11px !important;"
              hide-details
              label="ETA Policy"
              item-value="value"
              item-text="name"
            />
      </v-flex>    
      <v-flex pt-4 shrink px-2>
        <v-btn @click="submit"> {{ this.editMode ? 'Update' : 'Create' }}</v-btn>
      </v-flex>
    </v-row>
  </v-form>
</template>

<script>

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_group_form",
  components: {
  },
  props: {
    driverGroup: Object,
    editMode: Boolean
  },
  data: function() {
    return {
      etaPolicies: [
        {name: "About to clear", value:"about_to_clear_only"},
        {name: "Always", value:"always"},
        {name: "Never", value:"never"},
      ]
    };
  },
  mounted: function() {
  },
  methods: {
    errorForField: function(field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function(field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function() {
      this.$refs.loyaltyTierForm.validate();
    },
    submit: function() {
      console.log("SUBMITTED")
      this.$emit("create");
    }
  },
  watch: {
    valid: function() {
      this.$emit("validityChange", this.valid);
    }
  }
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>